let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d8clW")).then(() => parcelRequire('4layl'));